import { ITEM_SELECTION_ACTION } from "@progress/kendo-react-scheduler/dist/npm/Scheduler";

let data = [];
//var clearGridOnStart = false
const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    console.log(item , "Itemmmmmmm")
    item.ProductID = generateId(data);
    item.inEdit = false;
    // if(item.ProductID > 0 && data.length > 0){
    //     data.length = 0
    // }
    data.unshift(item);
    return data;
};
export const deleteAll = () => {
    data = [];
    return data;
};
export const getItems = () => {
    return data;
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
